module.exports = __webpack_public_path__ + "static/media/RP-54.af2fe0d1.pdf";